import { ifElse, isNumberHaveValue, someTrue } from 'aa_common/front-end/helpers'
import * as depreciationRatesApi from 'api/app/depreciationRates'
import { AssetLedger } from 'common/models'
import { FeatureFlagNames } from 'common/open-features'
import { useCheckFlag } from 'common/open-features/hooks'
import useResource from 'lib/hooks/useResource'
import { get } from 'lodash'
import { useEffect, useState } from 'react'

export function useGetDepreciation(ledger: AssetLedger) {
  const { isEnable: enablePartialImpairment } = useCheckFlag(FeatureFlagNames.PartialImpairment)
  const [depreciationRates, getDepreciationRates] = useResource(depreciationRatesApi.get)
  const [renderDepreciationRate, setDepreciationRate] = useState<any>(null)

  useEffect(() => {
    getDepreciationRates({
      depreciation_method: ifElse(
        someTrue(!enablePartialImpairment, !ledger?.original_depreciation_method_code),
        ledger.depreciation_method.code,
        ledger?.original_depreciation_method_code
      ),
      service_life: ifElse(
        someTrue(!enablePartialImpairment, !isNumberHaveValue(ledger?.original_service_life)),
        ledger?.service_life,
        ledger?.original_service_life
      ),
    })
  }, [ledger, enablePartialImpairment])

  useEffect(() => {
    if (depreciationRates.data?.length > 0) {
      const depreciationRateData = get(depreciationRates, 'data[0]')
      setDepreciationRate(depreciationRateData)
    }
  }, [depreciationRates])
  return { renderDepreciationRate }
}
